var map = {
	"./0.svg": 46269,
	"./1.svg": 80509,
	"./2.svg": 7884,
	"./3.svg": 42251,
	"./4.svg": 74339,
	"./5.svg": 69907,
	"./6.svg": 95310,
	"./7.svg": 55615,
	"data/edifices/A/tiers/0.svg": 46269,
	"data/edifices/A/tiers/1.svg": 80509,
	"data/edifices/A/tiers/2.svg": 7884,
	"data/edifices/A/tiers/3.svg": 42251,
	"data/edifices/A/tiers/4.svg": 74339,
	"data/edifices/A/tiers/5.svg": 69907,
	"data/edifices/A/tiers/6.svg": 95310,
	"data/edifices/A/tiers/7.svg": 55615
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 57953;